<section class="yoga format bg img-1 contact-us" id="contact">
  <div class="container contact-container">
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <div class="title title2">
          <h2 class="">Contact Us</h2>
          <!-- <img src="assets/images/yoga-img/logo/wave-blue.png" alt="" class="img-fluid"> -->
        </div>
      </div>
      <div
        class="col-md-6 experience-container"
        style="
          text-align: left;
          background-color: #273385;
          padding: 20px;
          border-radius: 20px;
        "
      >
        <h2 class="text-center mb-4">Our Practices</h2>
        
        <div class="practice-location mb-4">
          <h4>Table View</h4>
          <p>
            Baymed Centre<br>
            c/o Raats Dr/Arum Rd<br>
            Table View
          </p>
          <p><strong>Tel:</strong> 021 557 4515</p>
          <div style="margin-top: 10px;">
            <a href="https://g.co/kgs/CLvr1Mz" 
            target="_blank" 
            class="btn btn-neomorphism-primary">
           Get Directions
         </a>
          </div>
          
        </div>

        <div class="practice-location">
          <h4>Milnerton</h4>
          <p>
            Annex 116 Milnerton Medi-Clinic<br>
            Racecourse Rd<br>
            Milnerton<br>
            7441
          </p>
          <p><strong>Tel:</strong> 021 5511494</p>
          <div style="margin-top: 10px;">
            <a href="https://maps.google.com/?q=Annex+116+Milnerton+Medi-Clinic+Racecourse+Rd+Milnerton+7441" 
            target="_blank" 
            class="btn btn-neomorphism-primary">
           Get Directions
         </a>
          </div>
         
        </div>
      </div>
      <div class="col-md-5 experience-container contact-details">
        <div class="w-100">
          <form>
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <!-- <label for="name">Name:</label> -->
                  <input
                    type="text"
                    class="form-control"
                    id="name"
                    placeholder="Full name"
                  />
                  <small
                    *ngIf="nameRequired"
                    style="color: red"
                    class="form-text"
                    >Name required</small
                  >
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <!-- <label for="exampleInputEmail1">Email address</label> -->
                  <input
                    id="email"
                    type="email"
                    class="form-control"
                    aria-describedby="emailHelp"
                    placeholder="Email address"
                  />
                  <small id="emailHelp" class="form-text text-muted"
                    >We'll never share your email with anyone else.</small
                  >
                  <small
                    *ngIf="fromAddressRequired"
                    style="color: red"
                    class="form-text"
                    >Email address required</small
                  >
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <!-- <label for="exampleInputEmail1">Phone number:</label> -->
                  <input
                    id="phoneNumber"
                    type="text"
                    class="form-control"
                    placeholder="Phone number"
                  />
                  <small
                    *ngIf="telNoRequired"
                    style="color: red"
                    class="form-text"
                    >Phone number required</small
                  >
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <!-- <label for="exampleInputEmail1">Phone number:</label> -->
                  <textarea
                    id="message"
                    placeholder="Your message here.."
                    class="form-control"
                  ></textarea>
                  <small
                    *ngIf="messageRequired"
                    style="color: red"
                    class="form-text"
                    >Message required</small
                  >
                </div>
              </div>

              <div class="col-12 text-right">
                <a class="btn btn-neomorphism-primary" (click)="onSubmit()"
                  >SEND</a
                >
              </div>

              <div *ngIf="emailSent" class="col-12 text-right">
                <h5 style="color: green">Email sent.</h5>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
